import React from 'react';
import { Modal, Row, Col, Typography, Tag, Tooltip } from 'antd';

const { Text } = Typography;

const stateMap = {
  0: { color: 'default', label: '비활성' },
  1: { color: 'processing', label: '활성' },
  2: { color: 'success', label: '보상완료' },
};

const CollectionModal = ({ open, onClose, collection, mergeEventMainData }) => {
  return (
    <Modal
      title={<Text strong>컬렉션 목록</Text>}
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      <Row gutter={[8, 8]}>
        {collection.map((item) => {
          const info = Object.values(mergeEventMainData).find(e => e.collectionId === item.CollectionIndex) || {};
          const imgSrc = info.resourcePath ? `/UI/Images/Merge/MergeBlock/MergeBlockEvent/BossRaid/Theme01_Dessert/${info.resourcePath}.png` : '';
          const state = stateMap[item.CollectionRewardState] || stateMap[0];
          return (
            <Col span={4} key={item.CollectionIndex} style={{ textAlign: 'center' }}>
              <Tooltip title={info.blockName || `컬렉션 ${item.CollectionIndex}`}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <img
                    src={imgSrc}
                    alt={info.blockName || item.CollectionIndex}
                    style={{ width: 64, height: 64, objectFit: 'contain', borderRadius: 8, border: '1px solid #eee', marginBottom: 6 }}
                  />
                  <Text strong>ID: {item.CollectionIndex}</Text>
                  <Tag color={state.color} style={{ marginTop: 2, fontSize: 12 }}>{state.label}</Tag>
                </div>
              </Tooltip>
            </Col>
          );
        })}
      </Row>
    </Modal>
  );
};

export default CollectionModal;
